import React, { Component } from 'react';
import { Nav, NavItem, Navbar, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import './Header.css';
import hanko from '../assets/images/hanko.png';


class Header extends Component {
  render() {
    return (
      <Navbar staticTop className="Header-navbar">
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">
              <Image className="Header-hanko" src={hanko} />
            </Link>
          </Navbar.Brand>
        </Navbar.Header>
        <Nav pullRight>
          <LinkContainer className="Header-link" to="/about" activeClassName="active">
            <NavItem>ABOUT</NavItem>
          </LinkContainer>
        </Nav>
      </Navbar>
    );
  }
}
          // <LinkContainer className="Header-link" to="/writing" activeClassName="active">
          //   <NavItem>WRITING</NavItem>
          // </LinkContainer>

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js